// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableS-Scene.tableS-type3-Scene {
  margin-right: 9.4vw;
}

.tableS-mainsubtitle--type3 {
  left: 45vw;
}
.tableS-board-game--Type3 {
  display: flex;
  flex: 1 1;
  justify-content: center;
  align-items: center;
  margin-right: 2.6vw;
}
.tableS-table--Type3 {
  display: grid;
  grid-template-columns: 8vw 6vw 12vw 3vw;
  width: max-content;

  background: white;

  border: 0.1vw solid #1a6a7c;

  box-shadow:
    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),
    0 0.3vw 1vw rgba(0, 0, 0, 0.08);
}

.tableS-header--Type3 {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 3vw;

  font-size: 1.5vw;
  font-weight: bold;

  color: #184954;
  background: rgb(152, 213, 204);

  border-right: 0.1vw solid #1a6a7c;
  border-bottom: 0.1vw solid #1a6a7c;
}

.tableS-cell--Type3 {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 3vw;

  font-size: 1.6vw;
  font-weight: bold;

  background: white;

  border-right: 0.1vw solid #1a6a7c;
  border-bottom: 0.1vw solid #1a6a7c;
}

.tableS-input--Type3 {
  text-transform: uppercase;
  width: 100%;
  height: 3vw;

  padding: 0;

  border: none;
  border-right: 0.1vw solid #1a6a7c;
  border-bottom: 0.1vw solid #1a6a7c;

  outline: none;

  text-align: center;
  font-size: 1.5vw;
  font-weight: bold;

  background: white;
}

.tableS-input--Type3:disabled {
  background: #f6f6f6;
  color: #777;
}

.tableS-check--Type3 {
  display: flex;
  justify-content: center;
  align-items: center;

  border-right: 0.1vw solid #1a6a7c;
  border-bottom: 0.1vw solid #1a6a7c;
}

.tableS-icon----Type3 {
  width: 2vw;
  cursor: pointer;
}

.tableS-idle--Type3 {
  background: white;
}

.tableS-active--Type3 {
  background: #eef9ff;
}

.tableS-wrong--Type3 {
  background: #ffdede;
}

.tableS-input--Type3:disabled.tableS-correct--Type3 {
  background-color: #b8f5b8;
  color: #333;
}
/* Последний столбец */
.tableS-table--Type3 > :nth-child(4n) {
  border-right: none;
}

/* Последняя строка */
.tableS-table--Type3 > :nth-last-child(-n + 4) {
  border-bottom: none;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/TablesSecret/styles/TablesSBoardType3.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uCAAuC;EACvC,kBAAkB;;EAElB,iBAAiB;;EAEjB,2BAA2B;;EAE3B;;mCAEiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,WAAW;;EAEX,gBAAgB;EAChB,iBAAiB;;EAEjB,cAAc;EACd,8BAA8B;;EAE9B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,WAAW;;EAEX,gBAAgB;EAChB,iBAAiB;;EAEjB,iBAAiB;;EAEjB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;;EAEX,UAAU;;EAEV,YAAY;EACZ,iCAAiC;EACjC,kCAAkC;;EAElC,aAAa;;EAEb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;EAEjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB","sourcesContent":[".tableS-Scene.tableS-type3-Scene {\n  margin-right: 9.4vw;\n}\n\n.tableS-mainsubtitle--type3 {\n  left: 45vw;\n}\n.tableS-board-game--Type3 {\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n  margin-right: 2.6vw;\n}\n.tableS-table--Type3 {\n  display: grid;\n  grid-template-columns: 8vw 6vw 12vw 3vw;\n  width: max-content;\n\n  background: white;\n\n  border: 0.1vw solid #1a6a7c;\n\n  box-shadow:\n    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),\n    0 0.3vw 1vw rgba(0, 0, 0, 0.08);\n}\n\n.tableS-header--Type3 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  height: 3vw;\n\n  font-size: 1.5vw;\n  font-weight: bold;\n\n  color: #184954;\n  background: rgb(152, 213, 204);\n\n  border-right: 0.1vw solid #1a6a7c;\n  border-bottom: 0.1vw solid #1a6a7c;\n}\n\n.tableS-cell--Type3 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  height: 3vw;\n\n  font-size: 1.6vw;\n  font-weight: bold;\n\n  background: white;\n\n  border-right: 0.1vw solid #1a6a7c;\n  border-bottom: 0.1vw solid #1a6a7c;\n}\n\n.tableS-input--Type3 {\n  text-transform: uppercase;\n  width: 100%;\n  height: 3vw;\n\n  padding: 0;\n\n  border: none;\n  border-right: 0.1vw solid #1a6a7c;\n  border-bottom: 0.1vw solid #1a6a7c;\n\n  outline: none;\n\n  text-align: center;\n  font-size: 1.5vw;\n  font-weight: bold;\n\n  background: white;\n}\n\n.tableS-input--Type3:disabled {\n  background: #f6f6f6;\n  color: #777;\n}\n\n.tableS-check--Type3 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  border-right: 0.1vw solid #1a6a7c;\n  border-bottom: 0.1vw solid #1a6a7c;\n}\n\n.tableS-icon----Type3 {\n  width: 2vw;\n  cursor: pointer;\n}\n\n.tableS-idle--Type3 {\n  background: white;\n}\n\n.tableS-active--Type3 {\n  background: #eef9ff;\n}\n\n.tableS-wrong--Type3 {\n  background: #ffdede;\n}\n\n.tableS-input--Type3:disabled.tableS-correct--Type3 {\n  background-color: #b8f5b8;\n  color: #333;\n}\n/* Последний столбец */\n.tableS-table--Type3 > :nth-child(4n) {\n  border-right: none;\n}\n\n/* Последняя строка */\n.tableS-table--Type3 > :nth-last-child(-n + 4) {\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
